<template>
  <button
    type="submit"
    :disabled="isDisabled"
    :class="componentClass"
    :style="componentStyle"
    @click="(event) => $emit('click', event)"
  >
    {{ currentLabel }}
    <span
      v-if="iconName || isProcessing"
      class="margin-left-2xs"
    >
      <font-awesome-icon
        v-if="isProcessing"
        :icon="$v6[iconStyle][isProcessingIconName]"
        :size="iconSize !== '' ? iconSize : null"
        fixed-width
        v-bind="{ [isProcessingIconAnimation]: true }"
      />
      <font-awesome-icon
        v-else
        :icon="$v6[iconStyle][iconName]"
        :size="iconSize !== '' ? iconSize : null"
        fixed-width
      />
    </span>
  </button>
</template>

<script>
  export default {
    name: 'ActionButton',

    props: {
      isDisabled: {
        type: Boolean,
        default: false
      },
      iconName: {
        type: String,
        default: 'faArrowRight'
      },
      iconSize: {
        type: String,
        default: 'lg'
      },
      iconStyle: {
        type: String,
        default: 'solid'
      },
      isFullWidth: {
        type: Boolean,
        default: true
      },
      isLink: {
        type: Boolean,
        default: false
      },
      isSubtle: {
        type: Boolean,
        default: false
      },
      isProcessing: {
        type: Boolean,
        default: false
      },
      isProcessingIconName: {
        type: String,
        default: 'faSpinnerThird'
      },
      isProcessingLabel: {
        type: String,
        default: 'Processing…'
      },
      label: {
        type: String,
        required: true
      },
      size: {
        type: String,
        default: ''
      },
      customStyle: {
        type: Object,
        default: () => {}
      },
      theme: {
        type: String,
        default: 'primary'
      },
      isProcessingIconAnimation: {
        type: String,
        default: 'spin'
      }
    },

    computed: {
      currentLabel() {
        return this.isProcessing ? this.isProcessingLabel : this.label
      },
      componentStyle() {
        return {
          ...this.customStyle,
          ...{ '--button-margin-bottom': '0' }
        }
      },
      componentClass() {
        return [`${this.size} ${this.theme}`, { link: this.isLink }, { block: this.isFullWidth }, { 'pointer-events-none active': this.isProcessing }]
      }
    }
  }
</script>
